import isEqual from "lodash/isEqual";
import produce from "immer";

const initialState = {
  lastSelection: {},
  cartItems: [],
  orderConfirmed: false,
};

// action: { type, payload }
const cartReducer = (state = initialState, action) => {
  switch (action.type) {
    case "ADD_TO_CART":
      /*
				Approach:
				action.payload = { object with cart item data }
				loop over cart and find similar item
				if same i.e. ditto item is found, increase its qty
				else 
					push item to cart 
					replace lastSelection with this selection

			 */

      const newItem = action.payload.item;

      // DO NOT COMPARE OBJECTS WITH QUANTITY IN THEM
      const cloneItem = { ...newItem, quantity: true };

      const index = state.cartItems.findIndex((item) => {
        let tempItem = { ...item, quantity: true };
        return isEqual(tempItem, cloneItem);
      });

      if (index === -1) {
        // item is new
        return produce(state, (draft) => {
          draft.lastSelection.quantity = 1;
          draft.lastSelection[newItem._id] = newItem;
          draft.cartItems.push(newItem);
        });
      } else {
        // item already exists
        return produce(state, (draft) => {
          let currentQty = draft.cartItems[index].quantity;
          draft.lastSelection.quantity = 1;
          draft.lastSelection[newItem._id] = newItem;
          draft.cartItems[index].quantity =
            parseInt(currentQty) + parseInt(newItem.quantity);
        });
      }

    case "UPDATE_ITEM_QTY":
      return produce(state, (draft) => {
        draft.cartItems = action.payload.items;
      });
    case "EMPTY_CART":
      return produce(state, (draft) => {
        draft.cartItems = [];
        draft.lastSelection = {};
      });
    case "CONFIRM_ORDER":
      return {
        ...state,
        orderConfirmed: true,
      };
    case "REMOVE_ORDER_CONFIRM":
      return {
        ...state,
        orderConfirmed: false,
      };
    default:
      return state;
  }
};

export default cartReducer;
